<template>
  <drawer
    :transition-from-bottom="smallScreen"
    :is-open="drawerOpen"
    @close-drawer="closeDrawer">
    <template #header>
      <h4 class="typeset-3 mb-4">
        {{ t("product-page.sustainability-drawer.title") }}
      </h4>
    </template>
    <template #content>
      <div class="flex flex-col gap-y-7">
        <div
          v-for="(content, index) in sustainabilityContent"
          :key="index">
          <img
            class="mb-4"
            :src="content.img.src"
            :srcset="content.img.srcset"
            sizes="320px"
            height="160"
            width="320" />
          <h5 class="typeset-6 mb-3">
            {{ t(content.title_key) }}
          </h5>
          <p>
            {{ t(content.description_key) }}
          </p>
        </div>
        <div class="py-6 w-full flex justify-center">
          <a
            href="/sustainability"
            class="btn btn-large btn-block btn-primary">
            {{ t("product-page.sustainability-drawer.learn-more") }}
          </a>
        </div>
      </div>
    </template>
  </drawer>
</template>

<script>
import Drawer from "@/app/javascript/components/shared/Drawer.vue";

export default {
  name: "SustainabilityExplainerDrawer",
  components: {
    Drawer
  },
  props: {
    sustainabilityContent: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      drawerOpen: false,
      smallScreen: false
    };
  },
  mounted() {
    const xsQuery = window.matchMedia("(max-width: 479px)");
    xsQuery.addListener(this.xsScreenSize);
    this.xsScreenSize(xsQuery);

    window.addEventListener(
      "openSustainabilityExplainerDrawer",
      this.openDrawer
    );
  },
  methods: {
    closeDrawer() {
      analytics.track(`Dismissed Sustainability Explainer Drawer`);
      this.drawerOpen = false;
    },
    openDrawer() {
      this.drawerOpen = true;
      analytics.track(`Opened Sustainability Explainer Drawer`);
    },
    xsScreenSize(mediaQuery) {
      if (mediaQuery.matches) {
        this.smallScreen = true;
      } else {
        this.smallScreen = false;
      }
    }
  }
};
</script>
